// import React from "react";
// import { styled, keyframes } from "@mui/material/styles";
// import { Step, StepLabel, Stepper, StepConnector } from "@mui/material";
// import CheckIcon from "@mui/icons-material/Check";
// import CloseIcon from "@mui/icons-material/Close";

// const fillLineAnimation = keyframes`
//   from {
//     width: 0%;
//   }
//   to {
//     width: 100%;
//   }
// `;

// export const CustomConnector = styled(StepConnector)(({ theme }) => ({
//   "&.MuiStepConnector-alternativeLabel": {
//     top: 10,
//     left: "calc(-50% + 16px)",
//     right: "calc(50% + 16px)",
//   },
//   "& .MuiStepConnector-line": {
//     position: "relative",
//     height: 3,
//     border: 0,
//     backgroundColor: theme.palette.grey[300],
//     borderRadius: 1,
//     overflow: "hidden",
//   },
//   // Active or completed => fill in green by default
//   "&.Mui-active .MuiStepConnector-line::before, &.Mui-completed .MuiStepConnector-line::before":
//   {
//     content: '""',
//     position: "absolute",
//     left: 0,
//     top: 0,
//     height: "100%",
//     width: "100%",
//     backgroundColor: "#4caf50",
//     animation: `${fillLineAnimation} 1.5s forwards`,
//     animationDelay: "var(--connector-delay, 0s)",
//   },
// }));

// export const CustomStepper = styled(Stepper)(() => ({
//   // Delay the fill animation for each connector
//   "& .MuiStepConnector-root:nth-of-type(1)": {
//     "--connector-delay": "0s",
//   },
//   "& .MuiStepConnector-root:nth-of-type(2)": {
//     "--connector-delay": "2s",
//   },
//   "& .MuiStepConnector-root:nth-of-type(3)": {
//     "--connector-delay": "4s",
//   },
//   "& .MuiStepConnector-root:nth-of-type(4)": {
//     "--connector-delay": "6s",
//   },
// }));

// export const CustomStepIcon = (props) => {
//   const { active, completed, className, label, activeStep, index } = props;
// /*
//   circleColor = completed
//     ? "#4caf50"
//     : index == activeStep + 1
//       ? "#bdbdbd"
//       : "#bdbdbd";
// */

//   const isRejectedStep = label === "Order Rejected";

//   let circleColor = "#bdbdbd"; // default gray

//   if (isRejectedStep) {
//     circleColor = "#f44336"; // red for rejection
//   } else if (completed) {
//     circleColor = "#4caf50"; // green for completed
//   }

//   const circleStyle = {
//     backgroundColor: circleColor,
//     borderRadius: "50%",
//     width: 24,
//     height: 24,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     transition: `background-color 0.5s ease`,
//     color: "#fff",
//   };
  
//   return (
//     // <div className={className} style={circleStyle}>
//     //   {completed ? <CheckIcon key={label} style={{ fontSize: 16 }} /> : null}
//     // </div>

//     <div className={className} style={circleStyle}>
//       {isRejectedStep ? (
//         <CloseIcon style={{ fontSize: 16 }} />
//       ) : completed ? (
//         <CheckIcon key={label} style={{ fontSize: 16 }} />
//       ) : null}
//     </div>

//   );
// };
import React from "react";
import { styled, keyframes } from "@mui/material/styles";
import { Step, StepLabel, Stepper, StepConnector } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

// Animation for filling the connector line
const fillLineAnimation = keyframes`
  from {
    width: 0%;
    background-color: var(--connector-color,rgb(84, 193, 87));
  }
  to {
    width: 100%;
    background-color: var(--connector-color,rgb(84, 193, 87));
  }
`;

export const CustomConnector = styled(StepConnector)(({ theme }) => ({
  "&.MuiStepConnector-alternativeLabel": {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  "& .MuiStepConnector-line": {
    position: "relative",
    height: 3,
    border: 0,
    backgroundColor: theme.palette.grey[300],
    borderRadius: 1,
    overflow: "hidden",
  },
  // Active or completed => fill in green by default
  "&.Mui-active .MuiStepConnector-line::before, &.Mui-completed .MuiStepConnector-line::before": {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    height: "100%",
    width: "100%",
    backgroundColor: theme.palette.grey[300],
    animation: `${fillLineAnimation} 1.5s forwards`,
    animationDelay: "var(--connector-delay, 0s)",
  },
  // Special handling for rejected connectors
  "&.connector-rejected .MuiStepConnector-line::before": {
    backgroundColor: "#f44336", // Red for rejection
  }
}));

// This uses actual step transitions to create sequential appearance
export const CustomStepper = styled(Stepper)(({ theme }) => ({
  // Delay connector animations for each step
  "& .MuiStepConnector-root:nth-of-type(1)": {
    "--connector-delay": "-0.8s",
  },
  "& .MuiStepConnector-root:nth-of-type(2)": {
    "--connector-delay": "-0.8s",
  },
  "& .MuiStepConnector-root:nth-of-type(3)": {
    "--connector-delay": "-0.5s",
  },
  "& .MuiStepConnector-root:nth-of-type(4)": {
    "--connector-delay": "-0.5s",
  },
  
  // Add appearance animation for each step
  "& .MuiStep-root": {
    transition: "opacity 0.5s ease, transform 0.5s ease",
  },
  "& .MuiStep-root:nth-of-type(1)": {
    opacity: 1,
    transform: "translateY(0)",
    transitionDelay: "-0.5s",
  },
  "& .MuiStep-root:nth-of-type(2)": {
    opacity: "var(--step-opacity-2, 0.5)",
    transform: "translateY(var(--step-transform-2, 10px))",
    transitionDelay: "0.4s",
  },
  "& .MuiStep-root:nth-of-type(3)": {
    opacity: "var(--step-opacity-3, 1.5)",
    transform: "translateY(var(--step-transform-2, 10px))",
    transitionDelay: "0.6s",
  },
  "& .MuiStep-root:nth-of-type(4)": {
    opacity: "var(--step-opacity-4, 2.5)",
    transform: "translateY(var(--step-transform-3, 10px))",
    transitionDelay: "0.6s",
  },
  "& .MuiStep-root:nth-of-type(5)": {
    opacity: "var(--step-opacity-5, 3.5)",
    transform: "translateY(var(--step-transform-4, 10px))",
    transitionDelay: "0.7s",
  },
}));

export const CustomStepIcon = (props) => {
  const { active, completed, className, label, activeStep, index } = props;

  const isRejectedStep = label === "Order Rejected";

  let circleColor = "#bdbdbd"; // default gray

  if (isRejectedStep && (active || completed)) {
    circleColor = "#f44336"; // red for rejection
  } else if (completed) {
    circleColor = "#4caf50"; // green for completed
  } else if (active) {
    circleColor = "#1976d2"; // blue for active
  }

  const circleStyle = {
    backgroundColor: circleColor,
    borderRadius: "50%",
    width: 24,
    height: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.5s ease",
    color: "#fff",
  };
  
  return (
    <div className={className} style={circleStyle}>
      {isRejectedStep && (active || completed) ? (
        <CloseIcon style={{ fontSize: 16 }} />
      ) : completed ? (
        <CheckIcon style={{ fontSize: 16 }} />
      ) : null}
    </div>
  );
};